import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/device/reboot";

export class SendCaosRebootCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: SendCaosRebootReqData;

    constructor(params: SendCaosRebootReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class SendCaosRebootReqData {
    installationName: string;

    constructor(installationName: string) {
        this.installationName = installationName;
    }
}
